"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MobileNavOnBottom = exports.MobileNavOnTop = exports.MobileNavigation = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const web_blizzard_reporting_1 = require("@snapchat/web-blizzard-reporting");
const web_consumer_nav_1 = require("@snapchat/web-consumer-nav");
const MobileNavigation_module_css_1 = __importDefault(require("./MobileNavigation.module.css"));
const util_1 = require("./util");
const hooks_1 = require("../../utils/hooks");
const __1 = require("../..");
const clsx_1 = __importDefault(require("clsx"));
/**
 * Navigation for mobile browser
 */
function MobileNavigation(props) {
    const { appType, pageType, localeChange, locale, disableMobileBottomNav, showWhiteBgOnBottomNav, scrollDirection, hasLegacyOISCTA, } = props;
    const webClientId = props.webClientId ?? "";
    const { traceId: webPageViewTraceId } = (0, web_blizzard_reporting_1.useGenerateWebPageViewTraceId)();
    const pageId = web_blizzard_reporting_1.PageType[pageType].toLowerCase();
    const oneLinkParams = (0, __1.consumerWebOneLinkParams)(pageId, "https://link.snapchat.com/feed", `https://apps.apple.com/app/apple-store/id447188370?pt=614006&ct=${pageId}&mt=8`, `https://www.snapchat.com/download?sp=${pageId}`);
    const oneLinkUrl = (0, __1.tryGenerateOneLink)(oneLinkParams, webClientId, webPageViewTraceId);
    const onNavItemClick = (0, util_1.useOnConsumerNavItemClick)(pageType, true, webClientId);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(MobileNavOnTop, { locale: locale, downloadUrl: oneLinkUrl, pageType: pageType, onItemClick: (0, util_1.useOnItemClick)(pageType, true, webClientId), onGroupToggle: (0, util_1.useOnGroupToggle)(pageType, webClientId), localeChange: localeChange }), !disableMobileBottomNav && ((0, jsx_runtime_1.jsx)(MobileNavOnBottom, { locale: locale, appType: appType, pageType: pageType, scrollDirection: scrollDirection, onNavItemClick: onNavItemClick, chatIconOneLinkUrl: oneLinkUrl, showWhiteBg: showWhiteBgOnBottomNav, hasLegacyOISCTA: Boolean(hasLegacyOISCTA) }))] }));
}
exports.MobileNavigation = MobileNavigation;
/**
 * Hamburger Menu Icon on the top of a page
 */
function MobileNavOnTop(props) {
    return ((0, jsx_runtime_1.jsx)("div", { className: MobileNavigation_module_css_1.default.mobileNavContainer, "data-testid": "mobile-nav-top", children: (0, jsx_runtime_1.jsx)(web_consumer_nav_1.MobileNav, { locale: props.locale, downloadLink: props.downloadUrl, onItemClick: props.onItemClick, onGroupToggle: props.onGroupToggle, localeChange: props.localeChange, pageType: props.pageType }) }));
}
exports.MobileNavOnTop = MobileNavOnTop;
function getContainerStyle(scrollDirection) {
    // show new nav on the bottom of a page by default to promote consistency across all browsers
    if (scrollDirection === hooks_1.Scroll.REACH_BOTTOM) {
        return MobileNavigation_module_css_1.default.mobileNavV2Displayed;
    }
    // Show initially, hide when you scroll downwards and show when you scroll upwards
    else if (scrollDirection === hooks_1.Scroll.DOWN) {
        return MobileNavigation_module_css_1.default.mobileNavV2Hiddden;
    }
    return MobileNavigation_module_css_1.default.mobileNavV2Displayed;
}
/**
 * A set of Navigation Icons on the bottom of a page
 */
function MobileNavOnBottom(props) {
    const { showWhiteBg, locale, appType, scrollDirection, chatIconOneLinkUrl, onNavItemClick, hasLegacyOISCTA, } = props;
    return ((0, jsx_runtime_1.jsx)("div", { className: (0, clsx_1.default)(getContainerStyle(scrollDirection), {
            [MobileNavigation_module_css_1.default.whiteBg]: showWhiteBg,
            [MobileNavigation_module_css_1.default.legacyOisBottom]: hasLegacyOISCTA,
            [MobileNavigation_module_css_1.default.modernOisBottom]: !hasLegacyOISCTA,
        }), "data-testid": "mobile-nav-bottom", children: (0, jsx_runtime_1.jsx)(web_consumer_nav_1.MobileNavV2, { locale: locale, currentApp: (0, util_1.getConsumerApp)(appType), onNavItemClick: onNavItemClick, chatIconOneLinkUrl: chatIconOneLinkUrl }) }));
}
exports.MobileNavOnBottom = MobileNavOnBottom;
//# sourceMappingURL=MobileNavigation.js.map